import { render } from "./detail-bar.vue?vue&type=template&id=1a7cac3a"
import script from "./detail-bar.vue?vue&type=script&lang=js"
export * from "./detail-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__